// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"1671": "js-legacy","8626": "head-common","878": "stage_automation_icon","9474": "vendor",}[chunkId] || chunkId) + "-" + {"1671": "6f641bb46d24ee7c","3353": "d8a6fcbe4a198eab","4276": "9f686a4e047e7d65","8476": "92aa827e5c9630a8","8626": "94d26997ec94f48e","878": "2b37b8f851f4734a","8944": "919e582cfe107b79","9384": "d6ff5d2a99bb7acc","9474": "51b2001ae63a1bac",}[chunkId] + ".js"
}